import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { useSelector } from "react-redux";
import { selectStateProvList } from "../selectors";
import DeleteIcon from '@commonComponents/deleteIcon'

export const ActorDetailForm = React.memo(({ dataSource, translate, tableName, countryList, onChange, onSelect, onBlur, deleteData, displayState = false, renderAtFirst, renderAtLast, validateErrors }) => {




  const stateProvList = useSelector(selectStateProvList)
  const { id, name, eoriNo, city, state, country, countryCode, streetName, postalCode } = dataSource
  const onChangeHandler = useCallback(({ target: { value, name } }) => {
    onChange(id, tableName, { [name]: value })
    validateErrors && validateErrors()
  }, [tableName, id, onChange])

  const onDropDownChange = useCallback((e, { value, name }) => {
    let extraParams = {}
    if(name==='country'){
      extraParams.countryCode = value || ''
    }
    onSelect(id, tableName, { [name]: value, id, ...extraParams })
    validateErrors && validateErrors()

  }, [tableName, id, onSelect])

  const onBlurHandler = useCallback(({ target: { value, name } }) => {
    onBlur(tableName, { [name]: value, id })
    validateErrors && validateErrors()
  }, [tableName, id, onBlur])
  return (

    <div className="formContainer">
      <Grid.Row>
        {renderAtFirst && renderAtFirst({ dataSource, onBlurHandler, onChangeHandler, onDropDownChange })}
        <Grid.Column>
          <InputField
            id={`name-${tableName}-${id}`}
            type='text'
            name="name"
            value={name}
            label="NAME"
            clearInput={false}
            className="field-bg"
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column style={{ minWidth: '420px' }}>
          <InputField
            id={`streetName-${tableName}-${id}`}
            type='text'
            name="streetName"
            value={streetName}
            label="ADDRESS"
            clearInput={false}
            className="field-bg"
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />

        </Grid.Column>

        <Grid.Column>
          <InputField
            id={`postalCode-${tableName}-${id}`}
            type='text'
            name="postalCode"
            value={postalCode}
            label="ZIP"
            clearInput={false}
            className="field-bg"
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />

        </Grid.Column>

        <Grid.Column>
          <InputField
            id={`city-${tableName}-${id}`}
            name="city"
            type='text'
            value={city}
            label="PLACE"
            clearInput={false}
            className="field-bg"
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />

        </Grid.Column>
        {displayState && <Grid.Column>
          <DropDown
            id={`state-${tableName}-${id}`}
            name="state"
            value={state}
            text={state}
            clearable
            label="STATE_PROV"
            clearInput={false}
            data={stateProvList}
            onChange={onDropDownChange}
          />

        </Grid.Column>
        }
        <Grid.Column>
          <DropDown
            id={`country-${tableName}-${id}`}
            label="COUNTRY"
            name="country"
            direction="left"
            clearable
            labelClass="text-none"
            data={countryList}
            value={country}
            text={countryCode}
            onChange={onDropDownChange}
          />

        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`eoriNo-${tableName}-${id}`}
            name="eoriNo"
            type='text'
            value={eoriNo}
            label="EORI"
            clearInput={false}
            className="field-bg"
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>

        {renderAtLast && renderAtLast({ dataSource, onBlurHandler, onChangeHandler, onDropDownChange })}
      </Grid.Row>

      <div className="actionbtns">
        <DeleteIcon onClick={() => deleteData(id, tableName)} />
      </div>
    </div>

  );
})

ActorDetailForm.defaultProps = {
  translate: (value) => value
}